module.exports = __webpack_public_path__ + "static/media/ic_scanner.1911cd00.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_scanner.svg
// module id = 537
// module chunks = 0